import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [label, setLabel] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fine, setFine] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 45, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 500, damping: 45, mass: 0.6 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setFine(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setVisible(true);
    };
    const over = (e) => {
      const t = e.target.closest?.("[data-cursor]");
      setLabel(t ? t.dataset.cursor || "VIEW" : null);
    };
    const leave = () => setVisible(false);
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    document.documentElement.addEventListener("mouseleave", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.documentElement.removeEventListener("mouseleave", leave);
    };
  }, [x, y]);

  if (!fine) return null;

  return (
    <motion.div
      data-testid="custom-cursor"
      className="fixed top-0 left-0 z-[100] pointer-events-none"
      style={{ x: sx, y: sy, opacity: visible ? 1 : 0 }}
    >
      <motion.div
        className="flex items-center justify-center -translate-x-1/2 -translate-y-1/2 rounded-full bg-alta text-paper"
        animate={{
          width: label ? 68 : 12,
          height: label ? 68 : 12,
          backgroundColor: label ? "rgba(200,35,35,0.92)" : "#C82323",
        }}
        transition={{ type: "spring", stiffness: 350, damping: 28 }}
      >
        {label && (
          <span className="text-[10px] font-sans font-medium tracking-[0.2em] select-none">
            {label}
          </span>
        )}
      </motion.div>
    </motion.div>
  );
}
